import { useState } from 'react';
import { BrowserRouter as Router,
    Routes,
    Route,
    Link } from "react-router-dom";
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

// === Pages

    function CaseStudyPress( props  ) {

        let press = props.data

        if (press.data.length > 0) {
            console.log(press.data.length)
            return (
        
                <div className="main-content-wrapper">
                    <div className="case-study-info">
                    </div>
                    <div className="case-study-press-container" >
                        <div className="press-wrapper">
                            <h2>In The Press</h2>
                            <div className="press-bar"></div>
                            <div className="press-card-wrapper">
                                {press.data.map((entry) => 
                                    <div className="press-card-shadow">
                                        <div className="press-card">
                                            <img className="press-image" src={ `${ entry.attributes.Press_Image.data.attributes.url }` } />
                                            <div className="press-info">
                                                <div className='press-publication'>
                                                    <svg width="15" height="15" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12.1571 11.081V6.40892L12.158 6.40984L12.1571 1.07704L11.0801 0L1.07696 0L0 1.07704L0 11.081L1.07696 12.158H11.0801L12.1571 11.081Z" fill="#FFCD29"/>
                                                    </svg>
                                                    <p><em>{entry.attributes.Publication}</em></p>
                                                </div>
                                                <a target='_blank' className="no-underline" href={ `${ entry.attributes.Link }`}>
                                                    <h4>{entry.attributes.Title}</h4>
                                                </a>
                                                <BlocksRenderer content={ entry.attributes.Pull_Quote } />
                                            </div>
                                            <div className="press-card-bottom">
                                                <div style={{backgroundImage: `linear-gradient(225deg, rgba(254, 254, 228, 1) 50%, rgba(0, 0, 0, 0) 50%)`}} className="bl-tr-diagonal"></div>
                                                <div className="hexagon-middle-primary-util"></div>
                                                <div style={{backgroundImage: `linear-gradient(135deg, rgba(254, 254, 228, 1) 50%, rgba(0, 0, 0, 0) 50%)`}} className="tl-br-diagonal"></div>
                                            </div>
                                        </div>
                                    </div>
                                )}      
                            </div>    
                        </div>
                    </div>
                </div>
            );
        } else {
            return (null)
        }
    }
    
    export default CaseStudyPress;
